module.exports = __webpack_public_path__ + "img/tr.0b82c872.svg";